package com.milta.web

/**
 * Absolute URI for a `drawable/` Compose Resource, bypassing `Res.getUri()`.
 *
 * `Res.getUri("drawable/$file")`'s JS-target implementation does not do a real relative-URL
 * resolution against `<base href>` — it manually prepends `window.location.pathname` to the
 * resource path. That's harmless while the app is served at the site root, but DOM-06's routed
 * dashboard URLs (`/dashboard/settings`, `/dashboard/history/{id}`, ...) are never root, so any
 * image loaded this way 404s: e.g. on `/dashboard/settings`, a flag ends up requested at
 * `/dashboard/settings./composeResources/.../flags_flag_en.png` instead of the real
 * `/composeResources/.../flags_flag_en.png` — the literal "settings." artifact is
 * `window.location.pathname + "." + "/composeResources/..."`, not a browser relative-URL
 * resolution failure `<base href>` could fix.
 *
 * Verified server path (curl against the dev server, both the `dashboard`-prefixed and the
 * asset path): `/composeResources/miltafront.shared.generated.resources/drawable/<file>`. This
 * helper hardcodes that prefix with a **leading slash**, so it's already absolute-from-root and
 * immune to whatever the current pathname is. Used by every webApp screen that renders a
 * `drawable/` image ([WebWelcomeScreen], [DashboardShell], [WebSettingsScreen]) instead of
 * `Res.getUri("drawable/$file")`.
 */
internal fun drawableUri(file: String): String =
    "/composeResources/miltafront.shared.generated.resources/drawable/$file"
